import {RouterLinks} from "./router-links";

export enum FieldType {
  Password = 'password',
  Text = 'text',
  Email = 'email',
  Radio = 'radio',
  Checkbox = 'checkbox',
  //Select = 'select',
}

export let AccountFormFields = [
  { label: 'Civilité', param: 'civility', type: FieldType.Radio, pages: [RouterLinks.CreateAccount, RouterLinks.MyAccount] },
  { label: 'Prénom', param: 'firstname', type: FieldType.Text, pages: [RouterLinks.CreateAccount, RouterLinks.MyAccount]},
  { label: 'Nom', param: 'lastname', type: FieldType.Text, pages: [RouterLinks.CreateAccount, RouterLinks.MyAccount] },
  { label: 'Email', param: 'email', type: FieldType.Email, pages: [RouterLinks.CreateAccount, RouterLinks.MyAccount] },
  { label: 'ID RPPS', param: 'id_rpps', type: FieldType.Text, pages: [RouterLinks.CreateAccount, RouterLinks.MyAccount] },
  { label: 'Nom de l’officine', param: 'office_name', type: FieldType.Text, pages: [RouterLinks.CreateAccount, RouterLinks.MyAccount] },
  { label: 'Code postal de l’officine', param: 'office_cp', type: FieldType.Text, pages: [RouterLinks.CreateAccount, RouterLinks.MyAccount] },
  { label: 'Ville de l’officine', param: 'office_city', type: FieldType.Text, pages: [RouterLinks.CreateAccount, RouterLinks.MyAccount] },
  { label: 'Mot de passe', param: 'password', type: FieldType.Password, pages: [RouterLinks.CreateAccount] },
  { label: 'Confirmer le mot de passe', param: 'confirm_password', type: FieldType.Password, pages: [RouterLinks.CreateAccount] },
  { label: 'J’accepte que mes données soient conservées par Lohmann & Rauscher GmbH & Co. KG à des fins d’identification et d’accès aux données concernant les produits uniquement.', param: 'accept_terms', type: FieldType.Checkbox, pages: [RouterLinks.CreateAccount] },
  { label: 'Je souhaite recevoir la newsletter de Lohmann & Rauscher', param: 'accept_newsletter', type: FieldType.Checkbox, pages: [RouterLinks.CreateAccount, RouterLinks.MyAccount] },
];
